import { apiClient } from '../apiClient';

export const maintenanceService = {
  /**
   * Fetch maintenance status from the API
   * @returns {Promise<{success: boolean, status: boolean, message: string, timestamp: string}>}
   */
  async getMaintenanceStatus() {
    try {
      const response = await apiClient.get('/maintenance/status');
      return response;
    } catch (error) {
      console.error('Error fetching maintenance status:', error);
      // Return default status if API fails
      return {
        success: false,
        status: false,
        message: 'Unable to check maintenance status',
        timestamp: new Date().toISOString()
      };
    }
  }
};
